// do not manually modify this auto-generated file!!
import { FeatureFlagType } from './feature-flags.types';

export type AvailableFeatureFlags =
  | 'applet-prototype'
  | 'dynamicFlag'
  | 'environments-and-web-applets'
  | 'environments-ui'
  | 'fifthFlag'
  | 'first-demo-feature-flag'
  | 'manager-navigation-visibility'
  | 'managerProjectIdForContactCenter'
  | 'platform-integrations'
  | 'second-demo-feature-flag'
  | 'thirdFlagWithCamelCase'
  | 'wipChildOrgs'
  | 'wipTeams'
  | 'wipUsers';

export const DefaultFeatureFlags: FeatureFlagType = {
  'applet-prototype': 'false',
  dynamicFlag: 'false',
  'environments-and-web-applets': 'false',
  'environments-ui': 'false',
  fifthFlag: 'false',
  'first-demo-feature-flag': 'false',
  'manager-navigation-visibility': 'true',
  managerProjectIdForContactCenter: 'false',
  'platform-integrations': 'false',
  'second-demo-feature-flag': 'false',
  thirdFlagWithCamelCase: 'false',
  wipChildOrgs: 'false',
  wipTeams: 'false',
  wipUsers: 'false',
};
